import { Grid } from "@mui/material";
import { Control } from "react-hook-form";
import { Forms } from "@/types/form";
import constant from "@/utils/constant";
import { useParams } from "react-router-dom";
import { Params } from "@/types/utils";
import { Select, Input } from "@dippi/ui";
import { SELECT_ITEMS } from "@/utils/helpers";

interface Props {
    control: Control<Forms["Settings"]>;
}

const Address: React.FC<Props> = ({ control }) => {
    const { oid } = useParams<Params>();
    const isUpdate = Boolean(oid);

    return (
        <Grid item container xs={12} gap={constant.GRID_SPACING}>
            <Grid item xl={3} md={5} sm={5} xs={12}>
                <Select
                    data-testid="settings-country-select"
                    name="address.country"
                    control={control}
                    label="Country"
                    disabled={isUpdate}
                    items={SELECT_ITEMS.countries}
                />
            </Grid>
            <Grid item xl={3} md={5} sm={5} xs={12}>
                <Input
                    name="address.street"
                    control={control}
                    label="Street"
                    testId="settings-street-input"
                />
            </Grid>
            <Grid item container xs={12} gap={constant.GRID_SPACING}>
                <Grid item xl={1.5} lg={2} md={4} xs={12}>
                    <Input
                        name="address.city"
                        control={control}
                        label="City"
                        testId="settings-city-input"
                    />
                </Grid>
                <Grid item xl={1.5} lg={2} md={4} xs={12}>
                    <Input
                        name="address.zipCode"
                        control={control}
                        label="Post code"
                        testId="settings-zip-code-input"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Address;
